import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  image: {
    display: 'block',
    position: 'relative',
    width: ({ size }) => {
      switch (size) {
        case 'big':
          return 40;
        case 'medium':
          return 22.5;
        default:
          return 20;
      }
    },
    cursor: ({ interactive }) => (interactive ? 'pointer' : 'auto'),

    '&:not(:last-child)': {
      marginRight: ({ size }) => {
        switch (size) {
          case 'big':
            return theme.spacing(1.5);
          case 'medium':
            return theme.spacing(0.75);
          default:
            return theme.spacing(0.5);
        }
      },
    },
  },
}));
